export const CUSTOMER_CONTACT_TYPE = {
  PERSON: "CLIENT",
  BUSINESS: "BUSINESS",
} as const;

export type CustomerContactType =
  (typeof CUSTOMER_CONTACT_TYPE)[keyof typeof CUSTOMER_CONTACT_TYPE];

export const CUSTOMER_CONTACT_SOURCE = {
  CLIENT_DIRECTORY: "client_directory",
} as const;
